// PhysicsCalculatorsList.js
import React from 'react';
import { physicsCalculators } from './ConstantsPhysicsCalculator';
import SharedHelmet from '.././Helmet';
const TITLE = 'Kalkulator Fisika - Kalkulator Gratis untuk Menghitung Waktu Tempuh, Meter Kubik, Massa Besi, Lensa, Massa Air, dan Volume Gas';
const DESCRIPTION = 'Jelajahi koleksi kalkulator fisika gratis kami, termasuk kalkulator waktu tempuh, meter kubik, massa besi, kekuatan lensa mata, massa air, dan volume gas.';
const KEYWORDS = 'kalkulator fisika, kalkulator gratis, kalkulator waktu tempuh, kalkulator meter kubik, kalkulator kekuatan lensa mata';
const OG_URL = 'https://do-calculate.com/id/physics-calculators';
function CalculatorsList() {
    return (
        <div className="container ">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>{DESCRIPTION} </p>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th >Kalkulator</th>
                        <th >Deskripsi</th>
                     </tr>
                </thead>
                <tbody>
                    {physicsCalculators.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;